export const uniqBy = <T>(arr: T[], key: keyof T): T[] => {
  return Object.values(
    arr.reduce<Record<string, T>>((map, item) => {
      map[`${item[key]}`] = item;
      return map;
    }, {})
  );
};
